<template>
    <div class="row">
        <div class="col-12">
            <FormInput label="Descripción" type="text" name="descripcion" id="texto" rules="required" v-model="entrada.descripcion" />
        </div>
        <div class="col-12">
            <FormInput label="Zona" type="text" name="zona" id="zona" rules="required" v-model="entrada.zona" />
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="precio">Precio</label>
                <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                    <input type="decimal" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="precio" placeholder="Precio" v-model="entrada.precio">
                    <small>Gastos de gestión no incluidos - (Online: {{ gd_online }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.precio) + gd_online | formatear_precio }}) - (Taquilla: {{ gd_taquilla }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.precio) + gd_taquilla | formatear_precio }}).</small>
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12" v-if="!recinto">
            <FormInput label="Stock" type="text" name="stock" id="precio" rules="required" v-model="entrada.units" />
        </div>
        <div class="col-12 col-lg-6" v-if="!recinto">
            <FormInput label="Número mínimo de entradas por pedido" type="text" name="Mínimo" id="n_entradas_min" rules="required" v-model="entrada.n_entradas_min" />
        </div>
        <div class="col-12 col-lg-6" v-if="!recinto">
            <FormInput label="Número máximo de entradas por pedido" type="text" name="Máximo" id="n_entradas_max" rules="required" v-model="entrada.n_entradas_max" />
        </div>
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label for="fecha_inicio">Fecha de inicio de venta</label>
                <ValidationProvider name="fecha_inicio" rules="required" v-slot="{ errors }">
                    <datetime
                        v-model="entrada.sale_start_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_inicio"
                    ></datetime>
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label for="fecha_fin">Fecha de fin de venta</label>
                <ValidationProvider name="fecha_fin" rules="required" v-slot="{ errors }">
                    <datetime
                        v-model="entrada.sale_stop_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_fin"
                    ></datetime>
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12" v-if="!recinto">
            <div class="form-group">
                <label for="recinto">Tipo de entrada</label>
                <select v-model="entrada.visible" id="tipo" name="tipo" class="form-control">
                    <template v-for="tipo in tipos">
                        <option :key="tipo.tipo"  :value="tipo.tipo">{{ tipo.name }}</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="entrada.dia_abonado">
                    <label class="custom-control-label" for="customSwitch1">Entrada para abonados</label>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="manager.tipo == 2">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch3" v-model="entrada.restar_abonos">
                    <label class="custom-control-label" for="customSwitch3">Al comprar abonos restar stock en esta entrada. (Solo activarlo en una entrada para cada sesión)</label>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="requiere_verificacion" v-model="entrada.requiere_verificacion">
                    <label class="custom-control-label" for="requiere_verificacion">Requiere Verificación</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['entrada', 'sesion', 'recinto'],
        data() {
            return {
                tipos: [
                    {
                        tipo: 0,
                        name: 'Física'
                    },
                    {
                        tipo: 1,
                        name: 'Online'
                    },
                    {
                        tipo: 2,
                        name: 'Genérica (Online + Física)'
                    }
                ],
                vouchers: []
            }
        },
        created() {
            this.setFechaInicio();
            this.setFechaFin();
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            gd_online() {
                var gd = null;
                if(this.entrada.dia_abonado) {
                    gd = this.$store.getters.getGd['venta_dia_abono_online'];
                } else {
                    gd = this.$store.getters.getGd['venta_entrada_online'];
                }

                if(gd['interno']) {
                    return 0;
                }


                var cantidad = gd['cantidad'];

                if(gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.precio * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            },
            gd_taquilla() {
                var gd = null;
                if(this.entrada.dia_abonado) {
                    gd = this.$store.getters.getGd['venta_dia_abono_fisica'];
                } else {
                    gd = this.$store.getters.getGd['venta_entrada_fisica'];
                }

                if(gd['interno']) {
                    return 0;
                }

                var cantidad = gd['cantidad'];

                if(gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.precio * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            }
        },
        methods: {
            setFechaInicio() {
                if(!this.entrada.sale_start) {
                    this.entrada.sale_start = moment(new Date()).toISOString();
                }

            },
            setFechaFin() {
                if(!this.entrada.sale_stop) {
                    this.entrada.sale_stop = this.sesion.fecha_zulu;
                }

            },
            round (num, decimales = 2) {
                var signo = (num >= 0 ? 1 : -1);
                num = num * signo;
                if(decimales === 0) //con 0 decimales
                    return signo * Math.round(num);
                // round(x * 10 ^ decimales)
                num = num.toString().split('e');
                num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
                // x * 10 ^ (-decimales)
                num = num.toString().split('e');
                return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
            }
        }
    }
</script>
